import { render } from "./BottomNav.vue?vue&type=template&id=5be0069a&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"

import "./BottomNav.vue?vue&type=style&index=0&id=5be0069a&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/fprint/e-transaksi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be0069a"]])

export default __exports__